<template>
  <div class="order">
    <div class="filter-container">
      <el-form ref="form" :model="searchForm" :inline="true" :label-width="labelWidth">
        <el-form-item :label="$t('message.noticeContent') + ':'">
          <el-input
            v-model="searchForm.messageContent"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.type') + ':'">
          <el-select
            v-model="searchForm.messageType"
            filterable clearable
          >
            <el-option
              v-for="(item, index) in messageTypeList[$i18n.locale]"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('message.receiveTime') + ':'">
          <el-date-picker
            v-model="searchForm.createTime"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            :start-placeholder="$t('cart.startDate')"
            :end-placeholder="$t('cart.endDate')"
            style="width: 300px"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="searchButton">
        <div></div>
        <div>
          <el-button
            type="primary"
            class="primary-btn"
            @click="handleSearch"
          >
            <i class="subSearch-icon"></i>
            {{ $t("home.query") }}
          </el-button>
          <el-button
            type="primary"
            class="primary-btn"
            plain
            @click="handleResetQuery"
          >
            <i class="el-icon-refresh-right"></i>
            {{ $t("home.reset") }}
          </el-button>
        </div>
      </div>
    </div>
    <el-tabs
      v-model="activeName"
      class="tabs-container"
      @tab-click="handleClick"
    >
      <el-tab-pane :label="$t('home.all')" name="all"></el-tab-pane>
      <el-tab-pane :label="$t('request.unread')" name="0"></el-tab-pane>
      <el-tab-pane :label="$t('message.already')" name="1"></el-tab-pane>
    </el-tabs>
    <div class="table-container">
      <div class="table-btn">
        <el-button
          type="primary"
          class="primary-btn"
          size="mini"
          @click="handleAlready('selected')"
          :loading="btnLoading"
          >{{ $t("message.signAlready") }}</el-button
        >
        <el-button
          type="primary"
          class="primary-btn"
          size="mini"
          @click="handleAlready('all')"
          :loading="btnLoading"
          >{{ $t("message.allAlready") }}</el-button
        >
        <el-button
          type="primary"
          class="primary-btn"
          size="mini"
          @click="handleDelete('selected')"
          :loading="btnLoading"
          >{{ $t("message.batchDelete") }}</el-button
        >
      </div>
      <el-table
        ref="messageTable"
        row-key="messageId"
        :data="tableData"
        stripe
        border
        :max-height="maxHeight"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="55"
          align="center"
        >
        </el-table-column>
        <el-table-column
          type="index"
          :label="$t('cart.xh')"
          width="50"
          align="center"
          :render-header="$globalRenderHeader"
        >
        </el-table-column>
        <el-table-column
          prop="messageContent"
          :label="$t('message.noticeContent')"
          min-width="120"
           :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row["messageContent" + $i18n.locale] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="messageType"
          :label="$t('message.type')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.messageType === 0 ? $t("message.bh") : "" }}
            {{ scope.row.messageType === 1 ? $t("message.jp") : "" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('message.receiveTime')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop=""
          :label="$t('climant.status')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            {{
              scope.row.messageStatus === 0
                ? $t("request.unread")
                : $t("message.already")
            }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('cart.operate')"
          align="center"
          width="180px"
          fixed="right"
          :render-header="$globalRenderHeader"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="toDetail(scope.row)"
              >{{ $t("message.lookClimant") }}</el-button
            >
            <el-button
              v-if="scope.row.messageStatus === 0"
              type="text"
              @click="handleAlready('single', scope.row)"
              >{{ $t("message.signAlready") }}</el-button
            >
            <el-button
              type="text"
              @click="handleDelete('single', scope.row)"
              >{{ $t("cart.delete") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye">
        <pagination
          v-if="total > 0"
          :total="total"
          :page.sync="page"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :current-page="page"
          :page-sizes="[10, 15, 20, 30]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination> -->
      </div>
    </div>
  </div>
</template>
<script>
import { messageList, messageReading, messageDelete } from "@/api/seek";
import { setStorageNew } from "@/util/localStor";

export default {
  components: {},
  data() {
    return {
      activeName: "all",
      searchForm: {
        noticeContent: "",
        messageType: "",
        messageStatus: "",
        createTime: "",
      },
      messageTypeList: {
        zh: [
          {
            label: "驳回",
            value: 0,
          },
          {
            label: "拒赔",
            value: 1,
          },
        ],
        en: [
          {
            label: "Turn down",
            value: 0,
          },
          {
            label: "Claim repudiation",
            value: 1,
          },
        ],
        ru: [
          {
            label: "отклон",
            value: 0,
          },
          {
            label: "JuPei",
            value: 1,
          },
        ],
        fa: [
          {
            label: "رد کنید",
            value: 0,
          },
          {
            label: "بازداشتن پاداش",
            value: 1,
          },
        ],
      },
      searchForm: {},
      tableData: [],
      maxHeight:　null,
      page: 1,
      pageSize: 10,
      total: 0,
      btnLoading: false,
      ids: [],
    };
  },
  computed: {
    labelWidth () {
      const widthMap = {
        zh: '80px',
        en: '120px',
        ru: '125px',
        fa: '110px',
        vi: '160px',
        es: '210px'
      }
      return widthMap[this.$i18n.locale] || '150px'
    }
  },
  async mounted() {
    this.getList();
  },
  methods: {
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.messageId);
    },
    // 获取查询参数
    getParams() {
      const params = {
        ...JSON.parse(JSON.stringify(this.searchForm)),
      };
      if ((params.createTime || []).length === 2) {
        params.createTimeStart = params.createTime[0] + " 00:00:00";
        params.createTimeEnd = params.createTime[1] + " 23:59:59";
      }
      delete params.createTime;
      if (params.messageContent) {
        params["messageContent" + this.$i18n.locale] = params.messageContent;
      }
      delete params.messageContent;
      return params;
    },
    // 搜索
    handleSearch() {
      this.page = 1;
      this.pageSize = 10;
      this.getList();
    },
    // 重置查询条件
    handleResetQuery() {
      this.searchForm = Object.assign({}, this.$options.data()?.searchForm, {
        messageStatus: this.searchForm.messageStatus,
      });
      this.handleSearch();
    },
    // 切换tab
    handleClick(tab) {
      this.page = 1;
      this.pageSize = 10;
      this.searchForm.messageStatus = tab.name === "all" ? "" : tab.name;
      this.getList();
    },
    // 获取列表
    async getList() {
      let query = {
        data: this.getParams(),
        page: {
          pageNum: this.page,
          pageSize: this.pageSize,
        },
      };
      const res = await messageList(query);
      if (res.status == 0) {
        this.tableData = res.data?.records;
        this.total = res.data?.count;
      }
      this.getTableHighest(this, "maxHeight");
    },
    // // 每页显示条数
    // handleSizeChange(val) {
    //   this.pageSize = val;
    //   this.getList();
    // },
    // // 翻页
    // handlePageChange(val) {
    //   this.page = val;
    //   this.getList();
    // },
    handlePaginationChange(val) {
      this.page = val.page;
      this.pageSize = val.limit;
      this.getList();
    },
    // 查看索赔单
    toDetail(row) {
      setStorageNew("claimantData", {});
      this.$router.push({
        name: "claimantDetail",
        query: {
          messageId: row.messageId,
          claimantId: row.dataId,
          messageStatus: row.messageStatus,
        },
      });
    },
    // 标为已读
    async handleAlready(type, row) {
      var res = {};
      if (type === "selected" && !(this.ids && this.ids.length > 0)) {
        this.$DonMessage.warning(this.$t("placeholder.select"));
        return;
      }
      if (type === "selected") {
        res = await messageReading({ data: { messageList: this.ids } });
      }
      if (type === "all") {
        res = await messageReading({ data: { messageList: [] } });
      }
      if (type === "single") {
        res = await messageReading({ data: { messageList: [row.messageId] } });
      }
      if (res.status == 0) {
        this.$DonMessage.success(this.$t("message.czcg"));
        this.getList();
        this.$refs.messageTable.clearSelection();
      } else {
        this.$DonMessage.warning(res.message);
      }
    },
    // 删除
    async handleDelete(type, row) {
      var res = {};
      if (type === "selected" && !(this.ids && this.ids.length > 0)) {
        this.$DonMessage.warning(this.$t("placeholder.select"));
        return;
      }
      if (type === "selected") {
        res = await messageDelete({ data: { messageList: this.ids } });
      }
      if (type === "single") {
        res = await messageDelete({ data: { messageList: [row.messageId] } });
      }
      if (res.status == 0) {
        this.$DonMessage.success(this.$t("message.czcg"));
        this.getList();
        this.$refs.messageTable.clearSelection();
      } else {
        this.$DonMessage.warning(res.message);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
// .filter-container {
//   margin-top: 30px;
//   padding: 0 60px;
//   border-bottom: 5px solid #efefef;
//   ::v-deep .el-input {
//     width: 200px;
//   }
// }
.tabs-container {
  // padding: 30px 0 5px 0;
  // ::v-deep {
  //   .el-tabs__item {
  //     height: 30px;
  //     line-height: 30px;
  //   }
  //   .el-tabs__nav-wrap {
  //     padding: 0 7px 0 23px;
  //   }
  //   .el-tabs__nav-wrap::after {
  //     display: none;
  //   }
  //   .el-tabs__item.is-active {
  //     color: #bd3124;
  //   }
  //   .el-tabs__active-bar {
  //     background-color: #bd3124;
  //   }
  //   .el-tabs__item:hover {
  //     color: #bd3124;
  //   }
  // }
}
// .table-container {
//   padding: 0 7px 0 23px;
// }
</style>
